import type { Project } from '../types';

export const mockProjects: Project[] = [
  {
    id: 'proj-1',
    name: 'Website Redesign',
    description: 'Full redesign of the corporate website',
    status: 'active',
    isArchived: false,
    color: '#6366f1',
    icon: null,
    clientId: null,
    tenantId: 'org-1',
    startDate: null,
    endDate: null,
    createdAt: '2025-01-15T10:00:00Z',
    updatedAt: '2025-03-01T12:00:00Z',
  },
  {
    id: 'proj-2',
    name: 'Mobile App v2',
    description: 'Second iteration of the mobile application',
    status: 'active',
    isArchived: false,
    color: '#10b981',
    icon: null,
    clientId: null,
    tenantId: 'org-1',
    startDate: null,
    endDate: null,
    createdAt: '2025-02-01T09:00:00Z',
    updatedAt: '2025-03-10T14:00:00Z',
  },
  {
    id: 'proj-3',
    name: 'API Migration',
    description: 'Migrate REST API to GraphQL',
    status: 'archived',
    isArchived: true,
    color: '#f59e0b',
    icon: null,
    clientId: null,
    tenantId: 'org-1',
    startDate: null,
    endDate: null,
    createdAt: '2024-11-01T08:00:00Z',
    updatedAt: '2025-01-20T16:00:00Z',
  },
];
